import { create } from 'zustand';

interface Store {
  offerId: number;
  setOfferId: (offerId: number) => void;
}

const useProductOptionStore = create<Store>((set) => ({
  offerId: 0,
  setOfferId: (offerId: number) => set(() => ({ offerId })),
}));

export default useProductOptionStore;
